import React from 'react'
import classnames from 'classnames'

import Toggle from '../Form/toggle'
import Alert from '../../../../util/alert'

const Layout = ({searchConfig, advancedSearchActive}) => {
  const formSectionClassnames = classnames('form-section', { disabled: advancedSearchActive })

  return (
    <div className={formSectionClassnames}>
      <div style={{display: 'flex', gap: 20, alignItems: 'center'}}>

        {advancedSearchActive ? (
          <Toggle
            disabled={true}
            on={false}
            name="display_side_map">
            {locked => (
              <strong>
                Enable Left Side Map View ({locked ? 'On' : 'Off'})
              </strong>
            )}
          </Toggle>
        ) : (
          <Toggle
            disabled={advancedSearchActive}
            on={searchConfig.display_side_map}
            name="display_side_map">
            {locked => (
              <strong>
                Enable Left Side Map View ({locked ? 'On' : 'Off'})
              </strong>
            )}
          </Toggle>
        )}
      </div>

      <p className="muted">
        This setting changes the layout of the default search page, putting the listings on the right hand side of the screen, and the map on the left hand side of the screen.
      </p>

      <Alert
        header='Warning'
        description='Any custom CSS that was applied to customize the IDX may no longer apply with this display. Remember to clear your website and/or browser cache and check your CSS for any conflicts that may arise by changing this setting.'
      />

      <div style={{width: '100%', display: "flex", gap: 40, padding: 20}}>
        <div style={{display: 'flex', flexDirection: "column", flex: "1 1 0"}}>
          <p className="muted">Map Display Preview - Left</p>
          <img style={{height: "100%", width: "100%"}} src="/images/settings/side_map_layout.png" />
        </div>
        <div style={{display: 'flex', flexDirection: "column", flex: "1 1 0"}}>
          <p className="muted">Map Display Preview - Top</p>
          <img style={{height: "100%", width: "100%"}} src="/images/settings/stacked_map_layout.png" />
        </div>
      </div>
    </div>
  )
}

export default Layout



// WEBPACK FOOTER //
// client/components/sections/website/settings/Search/Layout.js